export default "__VITE_ASSET__Njtx_z86JRue_R_B55fIbA__"